export const malgorzataSolska = {
    'mydrId': 'małgorzatasolska',
    'firstName': 'Małgorzata',
    'lastName': 'Solska',
    'profession': 'Psycholog, Psychoterapeuta',
    'avatar': 'malgorzata-solska.webp',
    'slug': 'psycholog-malgorzata-solska',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'children'],
        ['psychology', 'consultation'],
        ['psychoterapy', 'parents']
    ]
}